import { CommanderFormProps, useDialogForm, useHandledDialogFormControls } from '@mews-commander/form';
import { createExperimentalZodFormResolver, lt } from '@mews/framework';
import { PortfolioCentralCancellationPoliciesAddParameters } from '@mews-commander/data-access';
import { FormValues, validationSchema } from '../../../schema';
import { CancellationPolicyFormContent } from '../CancellationPolicyFormContent';
import { useCentralCancellationPolicyAdd } from '../../../mutations';
import { getInitialValues } from './initialValues';

export const useCreateCancellationPolicyDialogForm = () =>
    useDialogForm({
        id: 'create-cancellation-policy',
        title: lt('CancellationPolicyNew'),
        saveLabel: lt('Create'),
        renderForm: (props) => <CreateCancellationPolicyForm {...props} />,
    });

const CreateCancellationPolicyForm = (props: CommanderFormProps) => {
    const { mutateAsync } = useCentralCancellationPolicyAdd();
    const { renderFormContent } = useHandledDialogFormControls<
        FormValues,
        PortfolioCentralCancellationPoliciesAddParameters
    >({
        ...props,
        resolver: createExperimentalZodFormResolver(validationSchema),
        defaultValues: getInitialValues(),
        onSubmit: async (values) => mutateAsync(values),
    });

    return renderFormContent(<CancellationPolicyFormContent shouldDisableBookablePeriodField={false} />);
};
